var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCamplayback(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.315,
    height: 9.626,
    viewBox: "0 0 15.315 9.626",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "np_playback_3493249_000000",
    d: "M27.077,26.867a.831.831,0,0,0-.854.036l-6.217,4.065V27.6a.834.834,0,0,0-1.291-.7L12.5,30.968v.9l6.217,4.065h0a.834.834,0,0,0,1.291-.7V31.868l6.217,4.065a.834.834,0,0,0,1.291-.7V27.6a.836.836,0,0,0-.437-.735Zm-7.9,8.368-5.839-3.817,5.84-3.817Zm7.508,0-5.839-3.817,5.84-3.817Z",
    transform: "translate(-12.349 -26.604)",
    fill: "#027aaa",
    stroke: "#027aaa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.3
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamplayback);
export default __webpack_public_path__ + "static/media/camplayback.a71460b0eb0514def11f429b319c6de0.svg";
export { ForwardRef as ReactComponent };